import React, { useLayoutEffect, useRef, useState } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import CollapsibleSlot from './CollapsibleSlot';

const ShowMoreLess = ({
  collapsedHeight = 170,
  showMoreText = 'Read more',
  showLessText = 'Read less',
  toggleButtonPosition = 'bottom',
  children,
}) => {
  const contentContainerRef = useRef(null);
  const toggleRef = useRef(null);

  const [isOpen, setOpen] = useState(false);

  useLayoutEffect(() => {
    if (collapsedHeight >= contentContainerRef.current.clientHeight) {
      setOpen(true);
      toggleRef.current.classList.add('hms-show-more-less__toggle--hidden');
    }
  }, []);

  return (
    <div className={cx('hms-show-more-less', `hms-show-more-less--${toggleButtonPosition}`)}>
      <CollapsibleSlot
        show={isOpen}
        initialSize={collapsedHeight}
        animationType=""
        unmountOnExit={false}
        className="hms-show-more-less__slot"
      >
        <div ref={contentContainerRef}>{children}</div>
      </CollapsibleSlot>
      <p
        ref={toggleRef}
        className="hms-show-more-less__toggle"
        onClick={() => setOpen(prevState => !prevState)}
      >
        {isOpen ? showLessText : showMoreText}
      </p>
    </div>
  );
};

ShowMoreLess.propTypes = {
  collapsedHeight: T.number,
  showMoreText: T.string,
  showLessText: T.string,
  toggleButtonPosition: T.oneOf(['top', 'bottom']),
  children: T.any.isRequired,
};

export default ShowMoreLess;
